import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Game from './components/Game/Game';
import Leaderboard from './components/Leaderboard/Leaderboard';
import Policy from './components/Policy/Policy';
import About from './components/About/About';
import AdBanner from './components/AdBanner/AdBanner';

function App() {
  // Initialize current page based on URL path
  const [currentPage, setCurrentPage] = useState(() => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('leaderboard')) return 'leaderboard';
    if (path.includes('about')) return 'about';
    if (path.includes('policy')) return 'policy';
    return 'game'; // Default to game for root path or any unknown path
  });

  // Function to handle navigation between pages
  const navigateTo = (page) => {
    // Update the URL without page reload
    const path = page === 'game' ? '/' : `/${page}`;
    window.history.pushState({}, '', path);
    setCurrentPage(page);
  };

  // Listen for browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('leaderboard')) setCurrentPage('leaderboard');
      else if (path.includes('about')) setCurrentPage('about');
      else if (path.includes('policy')) setCurrentPage('policy');
      else setCurrentPage('game');
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);


  // Render the appropriate component based on currentPage
  const renderPage = () => {
    switch (currentPage) {
      case 'leaderboard':
        return <Leaderboard navigateTo={navigateTo} />;
      case 'policy':
        return <Policy navigateTo={navigateTo} />;
      case 'about':
        return <About navigateTo={navigateTo} />;
      case 'game':
      default:
        // For the game page, show the ad banner on the left
        return (
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', height: '100%' }}>
            <div style={{ marginRight: 24 }}>
              <AdBanner />
            </div>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <Game navigateTo={navigateTo} />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="App">
      <Header navigateTo={navigateTo} activePage={currentPage} />
      <div className="main-content">
        {renderPage()}
      </div>
    </div>
  );
}

export default App;
